export default defineNuxtRouteMiddleware(async (to) => {
  const user = useSupabaseUser()
  
  if (!user.value) {
    return navigateTo({
      path: '/login',
      query: {
        redirect: to.fullPath,
      },
    })
  }

  try {
    const { data: userInfos } = await useUserInfos()
    
    if (!userInfos.value || userInfos.value.user_role !== 'admin') {
      return navigateTo('/')
    }
  } catch (error) {
    return navigateTo({
      path: '/login',
      query: {
        redirect: to.fullPath,
      },
    })
  }
}) 